export default function isScreenMobile(input) {
  const mediaQueryList = window.matchMedia(`(max-width: ${input || '767px'})`);
  return mediaQueryList.matches;
}
